import { extendTheme } from '@chakra-ui/react';
import breakpoints from './breakpoints';
import { radioTheme } from './radio';
import '@/app/globals.css';

const theme = extendTheme({
  direction: 'rtl',
  breakpoints,
  fonts: {
    heading: 'Yekan',
    body: 'Yekan',
  },
  components: {
    Radio: radioTheme,
    Tooltip: {
      baseStyle: {
        textAlign: 'center',
        m: 2,
        p: 1,
        borderRadius: 5,
      },
    },
  },
  zIndices: {
    overlay: 490,
    modal: 500,
    frame: 500,
    rotationAxis: 510,
    toolbox: 550,
    toolbar: 600,
    floatingToolbox: 610,
    addLayerTool: 620,
    tooltip: 700,
    goftino: 2000000003,
  },
  colors: {
    black: {
      500: 'black',
    },
    grey: {
      500: 'grey',
    },
  },
  styles: {
    global: {
      ':root': {
        '--toast-z-index': 2000000003, // above goftino
      },
      'html, body': {
        height: '100%',
        overflowX: 'hidden',
      },
      '.scrollarea': {
        overflow: 'hidden auto',
        ['&::-webkit-scrollbar']: {
          width: 2,
        },
        ['&::-webkit-scrollbar-track']: {},
        ['&::-webkit-scrollbar-thumb']: {
          backgroundColor: 'gray.100',
          borderRadius: '15px',
        },
      },
    },
  },
});

export default theme;
